<!--
 * @Author: your name
 * @Date: 2020-07-23 18:43:07
 * @LastEditTime: 2020-08-14 17:47:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-h5-workspace/packages/xdap-h5/src/pages/Home.vue
-->
<template>
  <div class="home-page">
    <footer-tab></footer-tab>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import Vue from 'vue'
import apis from '@/api'
import { mapMutations, mapState } from 'vuex'
import { SET_ORGS } from '@/store/auth.store.js'
import { SET_CURRENT_ORG, SET_DAPTENAT_VERSION } from '@/store/tenant.store.js'
import FooterTab from '@/components/footer-tab/index.vue'
// import { weComSdkInit } from '@/vender/third-sdk/we-com-sdk'
// import { isOnlyWeCom } from '@/lib/ui/utils/platform.util.js'
export default {
  components: {
    FooterTab
  },
  computed: {
    ...mapState({
      currentOrg: state => state.tenantModule.currentOrg
    })
  },
  // created() {
  //   if (isOnlyWeCom()) {
  //     weComSdkInit()
  //   }
  // },
  beforeRouteEnter(to, from, next) {
    const orgId = to.params.orgId
    if (typeof orgId !== 'undefined') {
      // Vue.prototype.$loading.show()
      const request = { ...apis.WORKBENCH.QUERY_MY_TENANT_LIST }
      Vue.prototype.$request(request)
        .asyncThen((resp) => {
          Vue.prototype.$loading.hide()
          if (resp.data && resp.data.length > 0) {
            const orgs = resp.data
            let currentOrg = {}
            const org = resp.data.filter((item) => item.id === orgId)[0]
            if (org) {
              currentOrg = org
              next((vm) => {
                vm.setCurrentOrg(currentOrg)
                vm.proxySetCurrentOrg(currentOrg)
                vm.setOrgs(orgs)
              })
            } else {
              currentOrg = resp.data.find((item) => item.activeFlag) || resp.data[0]
              next(vm => {
                vm.setOrgs(orgs)
                if (!vm.currentOrg || !vm.currentOrg.id) {
                  vm.setCurrentOrg(currentOrg)
                  vm.proxySetCurrentOrg(currentOrg)
                  vm.$router.push({ name: 'workbench', params: { orgId: currentOrg.id } })
                } else {
                  vm.$router.push({ name: 'workbench', params: { orgId: vm.currentOrg.id } })
                }
              })
            }
          } else {
            next((vm) => {
              vm.setOrgs({})
              vm.setCurrentOrg({})
              vm.$router.push({ name: 'org-setting' })
            })
          }
        }, (err) => {
          Vue.prototype.$loading.hide()
          next({ name: 'org-setting' })
        })
        .asyncErrorCatch((err) => {
          Vue.prototype.$loading.hide()
          next({ name: 'org-setting' })
        })
    } else {
      next()
    }
  },
  methods: {
    ...mapMutations('authModule', {
      setOrgs: SET_ORGS
    }),
    ...mapMutations('tenantModule', {
      setCurrentOrg: SET_CURRENT_ORG,
      setDaptenatVersion: SET_DAPTENAT_VERSION
    }),
    proxySetCurrentOrg(org) {
      const request = { ...apis.WORKBENCH.QUERY_USER_TENANT_INFO }
      request.params = {
        tenantId: org.id
      }
      return this.$request(request)
        .asyncThen(
          (resp) => {
            this.setCurrentOrg(resp.data)
            this.setDaptenatVersion(resp.data.limitId)
          },
          (error) => {
            this.setCurrentOrg(org)
            this.setDaptenatVersion()
          }
        )
        .asyncErrorCatch((error) => {
          this.setCurrentOrg(org)
          this.setDaptenatVersion()
        })
    }
  }
}
</script>

<style>
.home-page {
  height: 100%;
}
</style>
